<template>
  <div>
    <SessionItemSVG />
  </div>
</template>
<script>
import SessionItemSVG from "@/components/session/SessionItemSVG.vue";

export default {
  name: "SessionItemSvgPage",
  components: {
    SessionItemSVG,
  },
  data() {
    return {};
  },
};
</script>
